import { getErrorPayload } from '@application/common/helpers/api-helper';
export const assignmentErrorMessage = (error, action) => {
    const apiError = error && typeof error === 'object' && typeof error.status === 'number'
        ? error : getErrorPayload(error);
    if (apiError.status === 401)
        return `Your session expired. Sign in again to ${action}.`;
    if (apiError.status === 403)
        return `You are not allowed to ${action}.`;
    if (apiError.status === 404)
        return 'This assignment is no longer available. Refresh your assignments.';
    // Only validation responses may supply user-facing details; never render server exceptions.
    if ([400, 409, 422].includes(apiError.status)) {
        return apiError.validationErrors?.join(' ') || apiError.error || `The portal could not ${action}. Check the entered details and try again.`;
    }
    return `The portal could not ${action}. Try again.`;
};
